<template>
    <i class="link fa fa-edit" @click="triggerEditSetting()"></i>
</template>

<script>
import axios from "axios";

export default {
    setup() {
    },
    name: "EmployeeSettingProfilesButton",
    created() {
    },
    props: {
        employee_id: Number,
        setting: String
    },
    data() {
        return {
        };
    },
    computed: {
    },
    mounted() {
    },
    methods: {
        triggerEditSetting() {
            console.log('emit id ', this.absence_id);
            this.emitter.emit('edit-setting', {
                'employee_id': this.employee_id,
                'setting': this.setting
            });
        }
    }
};
</script>

<style scoped></style>
